class Helpers {

    /**
     * Document ready
     * @param fn
     */
    static ready (fn) {
        if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    /**
     * Helper function for extending objects
     */
    static extend (object /*, objectN ... */) {
        if (arguments.length <= 0) {
            throw new Error('Missing arguments in extend function');
        }

        const result = object || {};
        let key, i;

        for (i = 1; i < arguments.length; i++) {
            let replacement = arguments[i] || {};

            for (key in replacement) {
                if (replacement.hasOwnProperty(key)) {
                    // Recurse into object except if the object is a DOM element
                    if (typeof result[key] === 'object' && !isDOMElement(result[key])) {
                        result[key] = Helpers.extend(result[key], replacement[key]);
                    } else {
                        result[key] = result[key] || replacement[key];
                    }
                }
            }
        }

        return result;
    }

    /**
     * Mesure It
     */
    static outerHeight (el) {
        let height = el.offsetHeight;
        let style = getComputedStyle(el);

        height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);

        return height;
    }

    static triggerCustom (el, evType, params = { bubbles: true, cancelable: true, detail: {} }) {
        const p = params;
        let event = null;

        try {
            event = new CustomEvent(evType, p);
        } catch(e) {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(evType, p.bubbles, p.cancelable, p.detail);
        }

        el.dispatchEvent(event);
    }

    static triggerNative (el, evType) {
        const event = document.createEvent('HTMLEvents');
        event.initEvent(evType, true, false);

        el.dispatchEvent(event);
    }
}

export default Helpers;